import { arranjosPrincipais } from '../../../utils/arranjos'

export enum CercTypes {
    SUBMIT_OPT_IN = '@cerc/SUBMIT_OPT_IN',
    SUBMIT_OPT_OUT = '@cerc/SUBMIT_OPT_OUT',
    SUCCESS_OPT_IN = '@cerc/SUCCESS_OPT_IN',
    FAILURE_OPT_IN = '@cerc/FAILURE_OPT_IN',

    ADD_PAYMENTS = '@cerc/ADD_PAYMENTS',
    REMOVE_PAYMENTS = '@cerc/REMOVE_PAYMENTS',
    DELETE_ALL_PAYMENTS = '@cerc/DELETE_ALL_PAYMENTS',
    DELETE_ALL_PAYMENTS_OF_UR = '@cerc/DELETE_ALL_PAYMENTS_OF_UR',

    ADD_UNIDADE_RECEBIVEL = '@cerc/ADD_UNIDADE_RECEBIVEL',
    REMOVE_UNIDADE_RECEBIVEL = '@cerc/REMOVE_UNIDADE_RECEBIVEL',
    DELETE_ALL_UNIDADE_RECEBIVEL = '@cerc/DELETE_ALL_UNIDADE_RECEBIVEL',
    // DELETE_ALL_ADD_UNIDADE_RECEBIVEL = '@cerc/DELETE_ALL_ADD_UNIDADE_RECEBIVEL',
}

export interface OptInSubmitData {
    cnpj_cpf: string
}
export interface OptOutSubmitData {
    // optInSubmitId: number
    cnpj_cpf: string
}

export interface Pagamentos {
    id: number
    idUr: number
    agendaCodigoArranjoPagemento: string
    agendaEntidadeRegistradora: string
    AgendaInstituicaoCredenciadora: string
    uRDocumentoTitular: string
    uRDataLiquidacao: string
    DPNumeroDocumentoTitular: string
    DPTipoConta: string
    DPAgencia: string
    DPNumeroConta: string
    pagValorOnerado: string
    pagBeneficiario: string
    pagDataLiquidacaoEfetiva: string
}

export interface UnidadeRecebivel {
    id: number
    agendaId: number
    instituicaoCredenciadora: string
    codigoArranjoPagamento: keyof typeof arranjosPrincipais
    dataLiquidacao: string
    constituicao: string
    valorConstituidoTotal: string
    valorTotalUR: string
    valorConstituidoAntecipacaoPre: string
    valorBloqueado: string
    valorLivre: string
    valorLivreSelecionado: string
}

export interface CercState {
    error: string
    mensagem: string
    pagamentos: Array<Pagamentos>
    unidadesRecebiveisSelecionadas: Array<UnidadeRecebivel>
}
